module.exports = __webpack_public_path__ + "img/zp_7_mobile.37d34b00.jpg";